export default "__VITE_ASSET__OXkLz5jR__"